import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { OutputFormat } from '@capital-access/reporting/common';
import { LOCALIZATION_KEY } from '../../constants';
import { ProfileReportLayout } from '../../profile/models/profile-report-sections';

@Component({
  selector: 'ca-modify-report-drawer-footer',
  templateUrl: './modify-report-drawer-footer.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class ModifyReportDrawerFooterComponent {
  localizationScope = LOCALIZATION_KEY;
  @Input() disableSaving = false;
  @Input() createReportTitle!: string;
  @Input() isConfigurable!: boolean;
  @Input() templateId?: number;
  @Input() showFormatConversionOptions = false;
  @Output() closeDrawer = new EventEmitter();
  @Output() createReport = new EventEmitter<OutputFormat | undefined>();
  @Output() previewAndCustomize = new EventEmitter();

  ProfileReportLayout = ProfileReportLayout;
  OutputFormat = OutputFormat;

  get dropdownPlacement(): string {
    return this.isConfigurable ? 'top-left' : 'top-right';
  }

  cancel() {
    this.closeDrawer.emit();
  }

  onCreateReport(outputFormat?: OutputFormat) {
    this.createReport.emit(outputFormat);
  }

  getExportReportLink() {
    return `reporting/template-designer/export?id=${this.templateId}`;
  }

  onPreviewAndCustomizeClick() {
    this.previewAndCustomize.emit();
  }
}
